// Hydrate the data-src on the inner <video> only when the card enters the viewport,
// so we don't download ~7 MB of below-the-fold autoplay video on first paint.
// Falls back to immediate hydration when IntersectionObserver isn't available.
const ROOT_MARGIN = '200px 0px';

function hydrateVideoSrc(videoEl) {
    if (!videoEl) return;
    const src = videoEl.dataset.src;
    if (!src || videoEl.src) return;
    videoEl.src = src;
    delete videoEl.dataset.src;
    if (videoEl.autoplay) {
        const p = videoEl.play();
        if (p && p.catch) p.catch(() => { /* autoplay blocked, ignore */ });
    }
}

export default class TeaserCardVideo {
    static init() {
        const cards = document.querySelectorAll('.teaser-card--with-video');
        if (!cards.length) return;

        const isNeosBackend = document.body.classList.contains('neos-backend');
        if (isNeosBackend || typeof IntersectionObserver === 'undefined') {
            // Backend / no IO support: hydrate immediately, mirror previous behaviour.
            cards.forEach(el => {
                el.querySelectorAll('video[data-src]').forEach(hydrateVideoSrc);
                new TeaserCardVideo(el);
            });
            return;
        }

        const obs = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.querySelectorAll('video[data-src]').forEach(hydrateVideoSrc);
                obs.unobserve(entry.target);
            });
        }, { rootMargin: ROOT_MARGIN });

        Array.prototype.forEach.call(cards, el => {
            obs.observe(el);
            new TeaserCardVideo(el);
        });
    }

    constructor(element) {
        if (!element) return;
        this.element = element;

        const teaserCardLink = element.querySelector('.teaser-card__link');
        if (!teaserCardLink) return;

        teaserCardLink.addEventListener('mouseenter', () => {
            this.element.classList.add('teaser-card--is-playing');
        });
        teaserCardLink.addEventListener('mouseleave', () => {
            this.element.classList.remove('teaser-card--is-playing');
        });
    }
}
